import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/client/lib/utils';

export const Checkbox = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Checkbox({ className, ...props }, ref) {
    return (
      <input
        ref={ref}
        type="checkbox"
        className={cn(
          'h-[18px] w-[18px] rounded-[6px]',
          'border border-glass-border-strong bg-white/80 backdrop-blur-md',
          'accent-primary text-primary',
          'transition-[border-color,box-shadow,background] duration-200',
          'hover:border-primary/40',
          'focus-visible:outline-none focus-visible:border-primary focus-visible:shadow-glow',
          'disabled:opacity-55 disabled:cursor-not-allowed',
          className,
        )}
        {...props}
      />
    );
  },
);
